'use client';

import type { UserClubResponse } from '@1webit/cvs-api-scheme';
import Image from 'next/image';
import Link from 'next/link';

import { generateClubImageUrl } from '@/utils';

interface Props {
  club: UserClubResponse;
  onHide: () => void;
}

export const ClubSwiperItem = (props: Props) => {
  const {
    club,
    onHide,
  } = props;

  return (
    <Link
      href={`/clubs/${club.id}/detail`}
      key={club.id}
      onClick={onHide}
      className="flex w-full flex-col items-center gap-3"
    >
      <Image
        src={generateClubImageUrl(club.id)}
        alt="logo"
        width={108}
        height={108}
      />

      <div className="text-sm">
        <span className="font-semibold text-blue-600">{club.name}</span>
      </div>
    </Link>
  );
};
